// Simple Table of Contents with jQuery and scroll progress indicator
(function($) {
  // Flag to prevent multiple initializations
  var tocInitialized = false;
  
  $(document).ready(function() {
    // Exit if already initialized
    if (tocInitialized) {
      return;
    }
    
    // Core elements
    var $tocDesktop = $("#toc-container");
    var $tocMobile = $("#toc-container-mobile");
    var $content = $("#post-content");
    var $tocParent = $tocDesktop.closest('.single-post__toc');
    var $headings = $content.find("h2, h3, h4");
    var topOffset = 120; // Adjust based on header height
    
    // Generate TOC if headings exist
    if ($headings.length) {
      var tocItems = [];
      
      // Clear existing content to prevent duplication
      $tocDesktop.empty();
      $tocMobile.empty();
      
      // Create progress indicator for desktop and mobile
      $tocDesktop.append('<div class="single-post__toc-list-progress"></div>');
      $tocMobile.append('<div class="single-post__toc-list-progress"></div>');
      
      var $progressDesktop = $tocDesktop.find('.single-post__toc-list-progress');
      var $progressMobile = $tocMobile.find('.single-post__toc-list-progress');
      
      // Create TOC items from headings
      $headings.each(function(index) {
        var id = 'heading-' + index;
        var text = $(this).text().trim();
        var level = parseInt($(this).prop('tagName').charAt(1));
        var indent = level > 2 ? 'toc-indent' : '';
        
        // Add ID to heading
        $(this).attr('id', id);
        
        // Add to TOC items
        tocItems.push('<li class="' + indent + '"><a href="#' + id + '">' + text + '</a></li>');
      });
      
      // Add TOC to page
      var tocHtml = '<ul>' + tocItems.join('') + '</ul>';
      $tocDesktop.prepend(tocHtml);
      $tocMobile.prepend(tocHtml);
      
      // Cache all the TOC links for later use
      var $tocLinks = $('.single-post__toc a, .single-post__toc-mobile a');
      
      // Make TOC sticky on scroll and update progress
      $(window).on('scroll resize', function() {
        var scrollTop = $(window).scrollTop();
        var docHeight = $(document).height();
        var winHeight = $(window).height();
        var tocTop = $tocParent.parent().offset().top;
        var footerTop = $('.single-post__content-newsletter').offset().top;
        var tocHeight = $tocParent.outerHeight();
        
        // Calculate scroll progress as percentage
        var scrollPercent = (scrollTop / (docHeight - winHeight)) * 100;
        
        // Update progress indicator height
        $progressDesktop.css('height', scrollPercent + '%');
        $progressMobile.css('height', scrollPercent + '%');
        
        // Sticky positioning
        if (scrollTop > tocTop - topOffset) {
          if (scrollTop + tocHeight + topOffset < footerTop) {
            // Regular sticky position
            $tocParent.css({
              'position': 'fixed',
              'top': topOffset + 'px',
              'width': $tocParent.parent().width() + 'px'
            });
          } else {
            // Stop at footer
            $tocParent.css({
              'position': 'absolute',
              'top': (footerTop - tocHeight - $tocParent.parent().offset().top) + 'px',
              'width': $tocParent.parent().width() + 'px'
            });
          }
        } else {
          // Return to normal position
          $tocParent.css({
            'position': 'relative',
            'top': '0',
            'width': 'auto'
          });
        }
        
        // Highlight current section
        var currentId = null;
        
        $headings.each(function() {
          if (scrollTop + topOffset + 50 >= $(this).offset().top) {
            currentId = $(this).attr('id');
          }
        });
        
        if (currentId) {
          // Remove active class from all links
          $tocLinks.removeClass('active');
          
          // Add active class to current link
          $('.single-post__toc a[href="#' + currentId + '"], .single-post__toc-mobile a[href="#' + currentId + '"]').addClass('active');
          
          // Ensure active item is visible in container (auto-scroll TOC)
          var $activeLink = $('.single-post__toc a.active');
          if ($activeLink.length) {
            var $tocContainer = $tocDesktop;
            var linkTop = $activeLink.position().top;
            var containerHeight = $tocContainer.height();
            
            if (linkTop < 0 || linkTop > containerHeight) {
              $tocContainer.scrollTop($tocContainer.scrollTop() + linkTop - containerHeight/2);
            }
          }
        }
      });
      
      // Smooth scroll to sections
      $tocLinks.on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        
        // Add active class
        $tocLinks.removeClass('active');
        $(this).addClass('active');
        
        // Smooth scroll
        $('html, body').animate({
          scrollTop: $(target).offset().top - topOffset - 20
        }, 400);
      });
      
      // Trigger scroll once to initialize
      $(window).trigger('scroll');
      
      // Set the initialization flag
      tocInitialized = true;
    } else {
      $('.single-post__toc, .single-post__toc-mobile').hide();
    }
  });
  
  // // Additional check on window load to ensure proper initialization
  // $(window).on('load', function() {
  //   if (!tocInitialized) {
  //     $(document).ready();
  //   }
  // });
})(jQuery);